<template>
  <section v-bind:id="id" class="section">
    <h2>
      <i class="material-icons left">{{ iconName }}</i>
      {{ title }}
    </h2>

    <DadosContatoEmails
      v-bind:pessoa-fisica="pessoaFisica"
      v-bind:emails="email"
    />

    <DadosContatoTelefones
      v-bind:pessoa-fisica="pessoaFisica"
      v-bind:telefones="telefone"
    />

    <DadosContatoEnderecos
      v-bind:pessoa-fisica="pessoaFisica"
      v-bind:enderecos="endereco"
    />
  </section>
</template>

<script>
import DadosContatoEmails from "./DadosContatoEmails.vue";
import DadosContatoEnderecos from "./DadosContatoEnderecos.vue";
import DadosContatoTelefones from "./DadosContatoTelefones.vue";

export default {
  name: "DadosContato",
  components: {
    DadosContatoEmails,
    DadosContatoEnderecos,
    DadosContatoTelefones
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    title: String,
    iconName: String,

    pessoaFisica: Object,
    endereco: Array,
    telefone: Array,
    email: Array
  }
};
</script>
